
import { defineComponent, PropType, ref, computed, watch } from 'vue'
import { FieldStructure } from '@/contracts/forms/FieldContracts'

export default defineComponent(
{
    name: 'Select',
    emits: ['inputValueUpdated'],
    props:
    {
        field:
        {
            type: Object as PropType<FieldStructure>,
            default: {} as FieldStructure
        }
    },
    setup(props, { emit })
    {
        const inputValue = ref(props.field.value)

        const fieldGroupId = computed(() =>
        {
            return props.field.name + '-field-group'
        })

        const hintId = computed(() =>
        {
            return props.field.name + '-hint'
        })

        const errorId = computed(() =>
        {
            return props.field.name + '-error'
        })

        const fieldGroupClassList = computed(() =>
        {
            return {
                'govuk-form-group': true,
                'govuk-form-group--error': props.field.errors !== undefined
            }
        })

        const inputClassList = computed(() =>
        {
            return {
                'govuk-select': true,
                'govuk-select--error': props.field.errors !== undefined
            }
        })

        const inputDescribedBy = computed(() =>
        {
            let inputDescribedByString = ''
            inputDescribedByString += (props.field.hint !== undefined ? hintId.value + ' ' : '')
            inputDescribedByString += (props.field.errors !== undefined ? errorId.value + ' ' : '')
            return inputDescribedByString
        })

        watch(inputValue, (inputValue) => emit('inputValueUpdated',
        {
            name: props.field.name,
            value: inputValue
        }))

        // Return data:
        return {
            inputValue,
            fieldGroupId,
            hintId,
            errorId,
            fieldGroupClassList,
            inputClassList,
            inputDescribedBy
        }
    }
})
